import * as React from 'react';

import { StarInput, StarsRow } from '../../../components/NewReviewModal';
import { REVIEWS_VALUES } from '../../../constants/reviews';
import { isActive, isHovered } from './utils';

interface IProps {
  title: string;
  value: number;
  required?: boolean;
  onChange(value: number): void;
}

export function StarsSelect({ title, value, required, onChange }: IProps) {
  const [hover, setHover] = React.useState<number | null>(null);

  const getHandleChange = React.useCallback(
    (score: number) => () => {
      onChange(score);
    },
    [onChange],
  );

  const onMouseEnter = (value: number) => () => {
    setHover(value);
  };

  const onMouseLeave = () => {
    setHover(null);
  };

  return (
    <StarsRow title={title} required={required}>
      {REVIEWS_VALUES.map(score => {
        return (
          <StarInput
            isActive={isActive({ score, value })}
            isHover={isHovered({ score, hover })}
            name={title}
            value={score}
            key={score}
            onClick={getHandleChange(score)}
            onMouseEnter={onMouseEnter(score)}
            onMouseLeave={onMouseLeave}
          />
        );
      })}
    </StarsRow>
  );
}
